import apiFetch from '../apiFetch'
export default function (organizedUnitId, token, includeDeleted = true) {
  return apiFetch({ endPoint: `financeCompany/?organizedUnitId=${organizedUnitId}&includeDeleted=${includeDeleted}`, method: 'GET', body: null, token: token })
}
